import React from "react";
import { useNavigate } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import { Button } from "@ts-digital/vrc";
import { useDispatch } from "react-redux";
import { postReconciledToRegister } from "../../store/actions/reconciliation/operations";

const ReconciledSummaryCounter = ({
  reconciledSummary,
  auth,
  itemUuid,
  managerUuid  
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const createdReconciliations = reconciledSummary?.reconciliationsCreated;
  const notReconcilable = reconciledSummary?.notReconcilable;
  // lista di movimenti bancari (riconciliati o non riconciliabili e ancora da gestire dalla contabilizzazione)
  // estrapolata dalla chiamata in get al BE
  const requestList = reconciledSummary?.reconciliationSummaryApiRes;
  // dalla lista di movimenti bancari da contabilizzare, ricevuti in get, prendo solo quelli che hanno lo status in "created"
  // (nuove rinconciliazioni rispetto a quelle già inviate in contabilità), che devono essere rimandati indietro in post per la contabilizzazione
  const requestBodyListRaw = requestList.filter(transaction => transaction.reconciliationStatus === "CREATED");

  // elimino la chiave bankTransactionData dalla lista grezza dei movimenti bancari da contabilizzare
  const requestBodyList = requestBodyListRaw.map(el => {
    const { bankTransactionData, ...listWithNoTransactionData } = el;
    return listWithNoTransactionData;
  });

  const renderMovementsNum = createdReconciliations => {
    return <b>{createdReconciliations}</b>;
  };
  const renderNotReconcilableNum = notReconcilable => {
    return <b>{notReconcilable}</b>;
  };
  const renderToRegisterString = () => {
    return <b>da contabilizzare</b>;
  };
  const goToMovementsAccountingPage = () => {
    if (requestBodyList.length > 0) {
      dispatch(postReconciledToRegister(
        auth, requestBodyList, itemUuid, managerUuid
      ));
    }
    navigate({
      pathname: "/precog"
    },
    {
      state: {
        isFromBankPayments: true
      }
    });
  };
  return (
    <div className="dbx-reconciliation-summary-counter">
      <div className="dbx-reconciliation-summary-text-container">
        <p className="dbx-reconciliation-summary-description">
          {" "}
          <FormattedMessage
            id="deadlines.reconciliation.reconciledSummaryText"
            values={{
              movementsNum: renderMovementsNum(createdReconciliations),
              notReconcilableNum: renderNotReconcilableNum(notReconcilable),
              toRegisterString: renderToRegisterString()
            }}
          />{" "}
        </p>
        <Button
          kind="primary"
          onClick={() => goToMovementsAccountingPage()}
          size="large"
        >
          {" "}
          <FormattedMessage id="deadlines.reconciliation.reconciledSummaryCta" />{" "}
        </Button>
      </div>
    </div>
  );
};

export default ReconciledSummaryCounter;
